'use client';

import Image from 'next/image';

// Assets
import HomepageBanner from '@public/png/homepage-banner.png';

const Dedicated = () => {
  return (
    <div
      className="mt-0 mb-0 mx-auto py-[64px] w-full max-w-[1376px]
      dd3-2xl:py-[64px] dd3-2xl:max-w-[unset] dd2-2xl:px-[64px]
      dd3-xl:py-[48px] dd3-xl:px-[40px]
      dd3-lg:py-[32px] dd3-lg:px-[32px]
      dd3-md:px-[24px]"
    >
      <Image
        src={HomepageBanner}
        alt="Homepage banner"
        width={1344}
        height={774}
        className="w-full aspect-[16/9] object-cover rounded-xs"
      />
    </div>
  );
};

export default Dedicated;
